import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TuiLabel, TuiHint, TuiIcon, TuiRadio } from '@taiga-ui/core';
import { WorkflowFormFieldInputRadio } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-radio-field',
  imports: [
    ReactiveFormsModule,
    TuiHint,
    TuiLabel,
    TuiTooltip,
    TuiIcon,
    TuiRadio,
  ],
  templateUrl: './input-radio-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputRadioFieldComponent {
  field = input.required<WorkflowFormFieldInputRadio>();
  control = input.required<FormControl<string | null>>();
}
